var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUiIconUtility16Gas({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.258 1.536-.075.108a3.95 3.95 0 0 0-.652 2.64c.11.985.59 1.936 1.428 2.647.11.094.223.18.34.26a4.656 4.656 0 0 0 1.44-1.856c.844.354 1.483.848 1.932 1.437.573.754.832 1.657.829 2.594 0 1.414-.613 2.693-1.6 3.62-.998.937-2.377 1.514-3.9 1.514-1.523 0-2.902-.577-3.9-1.515-.985-.925-1.598-2.201-1.6-3.614a8.303 8.303 0 0 1 1.65-4.746C5.169 3.248 6.612 2.149 8.35 1.5l-.092.036z",
    stroke: "#FFDE00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiIconUtility16Gas);
export default __webpack_public_path__ + "static/media/ui-icon-utility-16-gas.1e5e8a7f.svg";
export { ForwardRef as ReactComponent };